/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { Observable, Subscription } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardDynamicComponent, StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { CASpecialPlanning } from 'src/app/model/control-access';
import { selectSpecialPlanningModifing, selectSpecialPlanningModify } from 'src/app/store/device/device.selector';
import moment from 'moment';
import { CustomValidators } from 'src/app/validators/custom.validators';

@Component({
	selector: 'app-control-access-special-planning-dialog',
	templateUrl: './control-access-special-planning-dialog.component.html',
})

export class ControlAccessSpecialPlanningDialogComponent implements OnInit, OnDestroy {

	specialPlanningModify$: Observable<boolean | undefined>;
	specialPlanningModifySub: Subscription | undefined;
	specialPlanningModifing$: Observable<boolean | undefined>;
	specialPlanningModifingSub: Subscription | undefined;


	specialPlanning: CASpecialPlanning;
	editMode = false;
	saving = false;

	specialPlanningForm: FormGroup;

	editedSub: Subscription;
	addedSub: Subscription;
	groupModifySub: Subscription;

	today: Date = new Date();

	// design
	screenWidth: number;

	constructor(
		private fb: FormBuilder,
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		this.specialPlanning = new CASpecialPlanning();
		if (config.data !== undefined && config.data.specialPlanning !== undefined) {
			this.specialPlanning.Id = config.data.specialPlanning.Id;
			this.specialPlanning.Access = config.data.specialPlanning.Access;
			this.specialPlanning.DtFrom = config.data.specialPlanning.DtFrom;
			this.specialPlanning.DtTo = config.data.specialPlanning.DtTo;
			this.specialPlanning.Name = config.data.specialPlanning.Name;
			this.editMode = true;
		} else {
			this.specialPlanning.DtFrom = moment().format('yyyy-MM-DDT00:00');
			this.specialPlanning.DtTo = moment().format('yyyy-MM-DDT23:59');
			this.specialPlanning.Access = false;
		}
		this.initSelectors();
	}

	initSelectors(): void {
		this.specialPlanningModify$ = this.store.select(selectSpecialPlanningModify);
		this.specialPlanningModifing$ = this.store.select(selectSpecialPlanningModifing);
	}

	ngOnInit(): void {
		this.specialPlanningForm = this.fb.group({
			'Name': new FormControl(this.specialPlanning.Name, [Validators.required, Validators.maxLength(48)]),
			'startDate': new FormControl(moment(this.specialPlanning.DtFrom.split('T')[0]).toDate(), Validators.required),
			'startTime': new FormControl(this.specialPlanning.DtFrom.split('T')[1], Validators.required),
			'endDate': new FormControl(moment(this.specialPlanning.DtTo.split('T')[0]).toDate(), Validators.required),
			'endTime': new FormControl(this.specialPlanning.DtTo.split('T')[1], Validators.required),
			'access': new FormControl(this.specialPlanning.Access),
		});
		this.specialPlanningForm.addValidators(CustomValidators.checkCorrectDateSequence('startDate', 'startTime', 'endDate', 'endTime'));

		this.subscribeAll();

		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	subscribeAll(): void {
		this.specialPlanningModifySub = this.specialPlanningModify$
			.pipe(filter(specialPlanningModify => !!specialPlanningModify))
			.subscribe(() => {
				this.resetClose();
			});
		this.specialPlanningModifingSub = this.specialPlanningModifing$
			.subscribe((editing) => {
				this.saving = editing;
			});
	}

	ngOnDestroy(): void {
		this.specialPlanningModifySub?.unsubscribe();
		this.specialPlanningModifingSub?.unsubscribe();
	}

	resetClose(): void {
		this.store.dispatch(DeviceActions.resetSpecialPlanningForm());
		this.closeDialog();
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.specialPlanningForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.specialPlanningForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	save(): void {
		const specialPlanning = { ...this.specialPlanning };
		specialPlanning.Name = this.f.Name.value;

		// DATE TIME START ELABORATION
		let startTimeStr = this.f.startTime.value.toString().toLowerCase()
		if (!/^\d$/.test(startTimeStr.charAt(0))) {
			// non è in formato numerico
			startTimeStr = startTimeStr.substring(16, 21)
			this.f.startTime.value = startTimeStr;
		}
		const momDateFrom = moment(this.f.startDate.value);
		const momTimeFrom = moment().local()
			.hours(+this.f.startTime.value.split(':')[0])
			.minutes(+this.f.startTime.value.split(':')[1]);
		specialPlanning.DtFrom = momDateFrom.format('yyyy-MM-DD') + momTimeFrom.format('THH:mm');
		// DATE TIME START ELABORATION
		// DATE TIME END ELABORATION
		let endTimeStr = this.f.endTime.value.toString().toLowerCase()
		if (!/^\d$/.test(endTimeStr.charAt(0))) {
			// non è in formato numerico
			endTimeStr = endTimeStr.substring(16, 21)
			this.f.endTime.value = endTimeStr;
		}
		const momTimeTo = moment().local()
			.hours(+this.f.endTime.value.split(':')[0])
			.minutes(+this.f.endTime.value.split(':')[1]);
		const momDateTo = moment(this.f.endDate.value);
		specialPlanning.DtTo = momDateTo.format('yyyy-MM-DD') + momTimeTo.format('THH:mm');
		// DATE TIME END ELABORATION
		specialPlanning.Access = this.f.access.value;

		if (this.specialPlanning.Id) {
			this.store.dispatch(DeviceActions.editSpecialPlanning({ specialPlanning: specialPlanning }));
		} else {
			this.store.dispatch(DeviceActions.addSpecialPlanning({ specialPlanning: specialPlanning }));
		}
	}


	get f(): any {
		return this.specialPlanningForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: ControlAccessSpecialPlanningDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: ControlAccessSpecialPlanningDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicDatepicker(): string {
		return StandardDynamicComponent.dynamicDatepicker(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicInputShortTextWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-23rem', 'w-30rem');
	}
}
